import { observer } from "mobx-react";
import { Input } from "../../../../../../../../../components/inputs/input/input";
import { CONDITION_OPERATORS } from "../../../../../../../policy-types";
import FontBody2 from "../../../../../../../../../components/fonts/font-body2/font-body2";
import { ICompareValueTypeComponentProps } from "../condition-field";
import IntegerBetweenCompareValueStore from "../../../../../../../stores/compare-value/integer-between-compare-value-store";

const IntegerBetweenCompareValueField: React.FC<ICompareValueTypeComponentProps> = observer(({store, condition, operatorSelector}) => {
    const compareValueStore: IntegerBetweenCompareValueStore = store as IntegerBetweenCompareValueStore;

    const shouldSHowToValue = condition.operator === CONDITION_OPERATORS.OP_BETWEEN_INTEGER;

    return (
        <>
            {operatorSelector}

            <Input disabled={!condition.isEditMode} type={'number'} min={0} value={compareValueStore.from} onChange={(v) => compareValueStore.setFrom(v)} placeholder="0" />

            {shouldSHowToValue && <>
                <FontBody2>and</FontBody2>
                <Input disabled={!condition.isEditMode}type={'number'} min={0} value={compareValueStore.to} onChange={(v) => compareValueStore.setTo(v)} placeholder="0" />
            </>}
            
            <FontBody2>items</FontBody2>            
        </>
    );
});

export default IntegerBetweenCompareValueField;